import { Button, Divider, Group, Select, Stack } from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconUsersMinus } from "@tabler/icons-react";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";
import { unsubList } from "../../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { useProfileStore } from "../../../../../stores/UserStore";
import DatafieldsSelector from "../../../../../components/Selectors/DatafieldsSelector";
import CronSettings from "../crons/CronSettings";

const UnsubDestination = ({
  id,
  type,
  isGlobal,
  handleClose,
  onFinish,
  selectedIds,
  filter,
}) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [org, setOrg] = useState(null);
  const [datafieldIds, setDatafieldsIds] = useState([1, 20]);

  const [loading, setLoading] = useState(false);

  const main = () => {
    const data = {
      id,
      organization_id: parseInt(org),
      ids: selectedIds,
      datafield_ids: datafieldIds,
      contacts_selection:
        type === "all" && !isGlobal
          ? undefined
          : {
              contact_ids:
                type === "selection_inverse" ? [] : selectedIds || [],
              excluded_contact_ids:
                type === "selection_inverse" ? selectedIds : [],
              filter:
                type === "filter" || type === "all"
                  ? transformFilterToServer(filter)
                  : { mode: "or", values: [] },
            },
    };

    setLoading(true);
    unsubList(data)
      .then((res) => {
        onFinish?.(type);
        notifications.show({
          message: lang.contact_lists.to_unsub.success,
          color: "tertiary.8",
        });
        handleClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack w={300}>
      <Stack gap={16}>
        {(type === "all" || type === "filter") && (
          <>
            <CronSettings
              isUnsub
              defaultFilter={
                type === "filter" ? transformFilterToServer(filter) : undefined
              }
            />

            <Divider />
          </>
        )}

        <Select
          label={lang.prm.unsub.org}
          placeholder={lang.prm.unsub.org}
          value={org}
          onChange={setOrg}
          data={profile?.organizations.map((x) => ({
            label: x.name,
            value: x.id.toString(),
          }))}
          comboboxProps={{
            zIndex: 1700,
            withinPortal: false,
          }}
        />

        <DatafieldsSelector
          label={lang.contact_lists.to_unsub.which_columns}
          placeholder={lang.contact_lists.to_unsub.columns}
          values={datafieldIds}
          onChange={(v) => setDatafieldsIds(v.map((x) => x.id))}
          zIndex={1700}
          withinPortal={false}
          required
        />
      </Stack>
      <Group justify="end">
        <Button
          leftSection={<IconUsersMinus size={16} />}
          onClick={main}
          loading={loading}
          color="red"
          disabled={datafieldIds.length === 0}
        >
          {lang.contact_lists.to_unsub.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default UnsubDestination;
